import { useQuery, UseQueryResult } from '@tanstack/react-query'
import { IAttribute } from '../../interfaces'
import { fetchAttributes } from '../../../../services/dtServices'
import { IOptions } from '../../../../services/apiInterfaces'

export const useGetAttributes = (
    orgId: string,
    entityId: string,
    options?: IOptions,
): UseQueryResult<IAttribute[], Error> => {
    return useQuery<IAttribute[]>({
        queryKey: ['attributes', entityId, orgId],
        queryFn: async () => {
            if (!orgId || !entityId) {
                return []
            }
            const respose = await fetchAttributes(orgId, entityId, options)
            if (!respose) {
                return []
            } else {
                const inheritedAttributes: IAttribute[] = []
                const selfAttributes: IAttribute[] = []
                const updatedRespose = respose.map((i) => {
                    return { ...i, ...{ uid: i.id } }
                })
                updatedRespose.forEach((attribute) => {
                    if (attribute.readOnly) {
                        inheritedAttributes.push(attribute)
                    } else {
                        selfAttributes.push(attribute)
                    }
                })
                const sortedSelfAttributes = selfAttributes.sort(
                    (a, b) => a.sequence - b.sequence,
                )
                return [...inheritedAttributes, ...sortedSelfAttributes]
            }
        },
        refetchOnWindowFocus: false,
    })
}
